import { resolveTrackArtists } from "../utils";

/** @typedef {{id: number, name: string}} ArtistCreditDto */
/** @typedef {{primary_artists?: ArtistCreditDto[], artists?: ArtistCreditDto[], featured_artists?: ArtistCreditDto[]}} TrackCreditsDto */

/** Return explicit primary credits not already shown as album artists. */
export function additionalPrimaryArtists(track) {
  const albumIds = new Set(
    resolveTrackArtists(track).map((artist) => artist.id),
  );
  const seen = new Set();
  return (track.primary_artists || []).filter((artist) => {
    if (albumIds.has(artist.id) || seen.has(artist.id)) return false;
    seen.add(artist.id);
    return true;
  });
}
